<template>
<div class="chapter">
<div class="inner_page">
<p class="p11">“Care less for your harvest than for how it is shared</p>
<p class="p12">And your life will have meaning and</p>
<p class="p12">Your heart will have peace.”</p>
<p class="p13">(Kent Nerburn)</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 007.vue?00ea26cc